const getReportTypeConfig = ({ reportType } = {}) => {
  const reportLabel = {
    click: '点击',
    expose: '曝光',
  };
  const label = reportLabel[reportType];
  return {
    type: 'fieldset',
    text: label,
    labelWidth: '80px',
    name: reportType,
    extensible: true,
    items: [{
      name: 'f_module',
      disabled: (vm, { values }) => !values?.report?.custom,
      text: 'f_module',
    }, {
      name: 'f_resource',
      disabled: (vm, { values }) => !values?.report?.custom,
      text: 'f_resource',
    }, {
      name: 'f_type',
      disabled: (vm, { values }) => !values?.report?.custom,
      text: 'f_type',
    }],
  };
};

export default {
  type: 'fieldset',
  text: '上报',
  labelWidth: '80px',
  name: 'report',
  items: [{
    type: 'row',
    items: [{
      type: 'switch',
      name: 'custom',
      defaultValue: false,
      text: '自定义',
      tip: '选择自定义后可以手动修改上报内容，关闭后会自动生成上报内容',
    }],
  }, {
    type: 'row',
    items: [
      getReportTypeConfig({ reportType: 'click' }),
      getReportTypeConfig({ reportType: 'expose' }),
    ],
  }],
};
